import React,{ useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import Header from './components/Header';
import Footer from './components/Footer';
import Register from "./components/Register";
import Login from "./components/Login";
import Home from "./components/Home";
import Cart from "./components/Cart";
import ProductDetails from "./components/ProductDetails";
import Checkout from "./components/Checkout";
import Contact from "./components/Contact";
import AllMen from "./components/AllMen";
import AllWomen from './components/AllWomen';
import Account from "./components/Account";
import Error from './components/404';
import { useStateValue } from './components/StateProvider';
import { auth } from "./firebase";
function App() {
 const [{ user }, dispatch] = useStateValue();

  useEffect(() => {
    auth.onAuthStateChanged(authUser => {
      console.log('The User is >>>', authUser);

      if (authUser) {

        dispatch({
          type: 'SET_USER',
          user: authUser,
        });
      } else {

        dispatch({
          type: 'SET_USER',
          user: null,
        })
      }
    })
  }, [dispatch])
  return (
    <Router>
    <div className="App">
      <Switch>

      <Route path="/my-account">
          <Header />
          <br /><br /><br /><br /><br />
          <Account />
          <br />
          <Footer />
        </Route>

        <Route path="/men-wears">
          <Header />
          <br /><br /><br /><br />
          <AllMen />
          <Footer />
        </Route>

        <Route path="/women-wears">
          <Header />
          <br /><br /><br /><br />
          <AllWomen />
          <Footer />
        </Route>

        <Route path="/contact-us">
          <Header />
          <br /><br /><br /><br /><br />
          <Contact />
          <br />
          <Footer />
        </Route>

        <Route path="/checkout">
          <Header />
          <br /><br /><br /><br />
          <Checkout />
          <br /><br />
          <Footer />
        </Route>

        <Route path="/product-details/:title">
          <Header />
          <br /><br /><br /><br />
          <ProductDetails />
          <Footer />
        </Route>

        <Route path="/login">
          <Header />
          <br /><br /><br /><br />
          <Login />
          <br /><br /><br /><br /><br />
          <Footer />
        </Route>

        <Route path="/register">
          <Header />
          <br /><br /><br /><br />
          <Register />
          <br /><br /><br />
          <Footer />
        </Route>

        <Route path="/cart">
          <Header />
          <br /><br /><br /><br />
          <Cart />
        </Route>

        <Route path="/home">
          <Header />
          <br /><br /><br /><br />
          <Home />
          <Footer />
        </Route>

       <Route path="/*">
        <Header />
         <br /><br /><br /><br /><br />
        <Error />
         <br />
        <Footer />
       </Route>

      </Switch>
    </div>
    </Router>
  );
}

export default App;
